import React from 'react';
import { ShieldCheckIcon, WrenchIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { BOX_IMAGE } from '../data/product';
export function Hero() {
  return <section className="bg-navy px-4 pb-6 pt-7 text-white sm:pb-8 sm:pt-9" data-id="element-70" data-mp="9kjxeqt8b84q">
      <div className="mx-auto max-w-4xl text-center" data-id="element-71" data-mp="9ip7sz70irub">
        <h1 className="text-[1.75rem] leading-[0.95] sm:text-5xl" data-id="element-72" data-mp="4mrsmw7hjrj4">
          THE COMPLETE VISUAL FAULT-FINDING SYSTEM FOR{' '}
          <span className="text-cyan" data-id="element-73" data-mp="128pijeo72z53">AUTOMOTIVE TECHNICIANS</span>
        </h1>

        <p className="mx-auto mt-3 max-w-3xl text-[0.9rem] font-medium leading-snug text-white/85 sm:text-lg" data-id="element-74" data-mp="xbpawzbp5obv">
          Stop diagnosing vehicle problems from scratch. Use ready-to-use
          diagnostic workflows, testing guides and fault-finding tools to move
          from symptoms and trouble codes to a clearer diagnostic path.{' '}
          <span className="font-bold text-white" data-id="element-75" data-mp="3cz5weevm861x">
            Find the fault. Follow the tests. Diagnose with confidence.
          </span>
        </p>

        <a href="#offer" className="mt-4 block" data-id="element-76" data-mp="3j9k7h1pgwzbd">
          <img src={BOX_IMAGE} alt="AUTOMOTIVE DIAGNOSTIC PRO™ complete 6-in-1 diagnostic system box set" className="mx-auto w-full max-w-md" loading="eager" data-id="element-77" data-mp="3o7lshs6gf8ph" />
        </a>

        <div className="mt-3 flex justify-center" data-id="element-78" data-mp="3e8mtz2fektg7">
          <CTAButton href="#offer" data-id="element-79" data-mp="3ebiqcmblra2j">🔧 YES! I WANT THE COMPLETE SYSTEM</CTAButton>
        </div>

        <p className="mt-2 font-display text-lg uppercase tracking-wide text-cyan sm:text-xl" data-id="element-80" data-mp="30fy87t3p6vw6">
          GET AUTOMOTIVE DIAGNOSTIC PRO™ TODAY
        </p>
        <ul className="mt-1.5 flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-[11px] font-semibold uppercase tracking-wide text-white/75 sm:text-xs" data-id="element-81" data-mp="2qkmt39odnmnw">
          <li className="flex items-center gap-1.5" data-id="element-82" data-mp="2hj5ejvqmbt1b">
            <ShieldCheckIcon className="h-4 w-4 text-cyan" aria-hidden="true" data-id="element-83" data-mp="2hkglg4fd1gwn" />
            7-Day Money-Back Guarantee
          </li>
          <li className="flex items-center gap-1.5" data-id="element-84" data-mp="2lmlaepuv5pcy">
            <WrenchIcon className="h-4 w-4 text-cyan" aria-hidden="true" data-id="element-85" data-mp="s333380kgeuw" />
            Complete 6-in-1 System
          </li>
        </ul>
      </div>
    </section>;
}